import React, { useContext } from "react";
import { Card, Row, Col, Table } from "react-bootstrap";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import NavbarComp from "../../shared/components/Navbar";
import { useDashboard } from "./hooks/useDashboard";
import { UserContext } from "../../shared/context/authContext";

const DashboardPage = () => {
  const { dashboardStat } = useDashboard();
  
  const visitorData = [
    { day: "Nov", visitors: 60 },
    { day: "Tue", visitors: 40 },
    { day: "Wed", visitors: 30 },
    { day: "Thu", visitors: 0 },
    { day: "Fri", visitors: 30 },
    { day: "Sat", visitors: 40 },
    { day: "Sun", visitors: 60 },
  ];


  const orders = [
    {
      tracking: "8:45:6:554",
      product: "Camera Lens",
      orders: 40,
      status: "Rejected",
      amount: "$49,570",
    },
    {
      tracking: "8:45:6:554",
      product: "Logico",
      orders: 300,
      status: "Pending",
      amount: "$180,139",
    },
  ];

  return (
    <>
      <NavbarComp />
      <div className="container-fluid p-4">
        {/* Summary Cards */}
        <Row className="g-4 mb-4">
          <Col md={3}>
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <h6 className="text-muted">Total Page Views</h6>
                <h4>
                  4,42,236 <span className="text-success">(63.3%)</span>
                </h4>
                <small className="text-muted">
                  You made an extra $5,800 this year
                </small>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <h6 className="text-muted">Total Users</h6>
                <h4>
                  78,250 <span className="text-success">(76.5%)</span>
                </h4>
                <small className="text-muted">
                  You made an extra $500 this year
                </small>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <h6 className="text-muted">Total Order</h6>
                <h4>
                  18,800 <span className="text-warning">(27.6%)</span>
                </h4>
                <small className="text-muted">
                  You made an extra $450 this year
                </small>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <h6 className="text-muted">Total Sales</h6>
                <h4>
                  $35,078 <span className="text-danger">(27.4%)</span>
                </h4>
                <small className="text-muted">
                  You made an extra $30,999 this year
                </small>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Charts Section */}
        <Row className="g-4">
          <Col md={4}>
            <Card className="shadow-sm">
              <Card.Body>
                <h5>Unique Visitor</h5>
                <div style={{ height: "300px" }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={visitorData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="day" />
                      <YAxis />
                      <Tooltip />
                      <Bar dataKey="visitors" fill="#8884d8" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={8}>
            <Card className="shadow-sm">
              <Card.Body>
                <h5>Income Overview</h5>
                {/* <h3 className="my-4">Rp {dashboardStat?.yearlyTotals?.total}</h3> */}
                <div style={{ height: "300px", fontSize: "0.7rem" }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={dashboardStat?.monthlyPayment}>
                      <Line
                        type="monotone"
                        dataKey="total_payment"
                        stroke="#82ca9d"
                      />
                      <XAxis dataKey="month" />
                      <YAxis />
                      <Tooltip />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Bottom Section */}
        <Row className="g-4 mt-4">
          <Col md={8}>
            <Card className="shadow-sm">
              <Card.Body>
                <h5>Recent Orders</h5>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>TRACKING NO.</th>
                      <th>PRODUCT NAME</th>
                      <th>TOTAL ORDER</th>
                      <th>STATUS</th>
                      <th>TOTAL AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((order, index) => (
                      <tr key={index}>
                        <td>{order.tracking}</td>
                        <td>{order.product}</td>
                        <td>{order.orders}</td>
                        <td>
                          <span
                            className={`badge ${order.status === "Rejected" ? "bg-danger" : "bg-warning"}`}
                          >
                            {order.status}
                          </span>
                        </td>
                        <td>{order.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="shadow-sm">
              <Card.Body>
                <h5>Analytics Report</h5>
                <ul className="list-unstyled mt-4">
                  <li className="mb-3">
                    <strong>Company Finance Growth</strong>
                    <div className="text-success">+45.14%</div>
                  </li>
                  <li className="mb-3">
                    <strong>Company Expenses Ratio</strong>
                    <div className="text-warning">0.58%</div>
                  </li>
                  <li>
                    <strong>Business Risk Cases</strong>
                    <div className="text-success">Low</div>
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DashboardPage;
